import { partnerClient } from '@modules/core/services';
import { KitFailureReasonResponse, KitFailureReasonParams } from '../types';

export const fetchKitFailureReason = async (queryParams: KitFailureReasonParams): Promise<KitFailureReasonResponse> => {
  return await partnerClient.get(`/studies/-/samples/kit-failure-reason`, {
    params: queryParams,
  });
};
